var map = {
	"./legend.svg": 2718,
	"./legend_level.svg": 3413,
	"./mystic.svg": 2910,
	"./mythic.svg": 5223,
	"./mythic_level.svg": 6516,
	"./normal.svg": 8396,
	"./normal_level.svg": 251,
	"./rare.svg": 9545,
	"./rare_level.svg": 9470,
	"./unique.svg": 5296,
	"./unique_level.svg": 1983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4217;